import axios from "axios";
import React, {useEffect, useState,useRef,Fragment} from "react";
import {Link, NavLink, useParams, useNavigate, useLocation} from "react-router-dom"
import { render } from "react-dom";
import clientconfigwebapp, {
    empty_bk,
    convert_to_english_strhk,
    scrollTo_uphk,
    check_login_appbk,
    Token_get_appbk,
    redirectbh_typeb,
    FormatNumberByhkh,
    Cart_get_list_product,
} from '../../clientconfigwebapp';
import { ToastContainer, toast } from 'react-toastify';

import Master_Front from "../../pages/Master_Front";

import "../../components/assets/css/profile.css"

import ReactFullPageLoadinghk from "../../components/layaout/LoadingFullpagehk";
import Menu_panel from "../../components/layaout/Menu-panel";

import Grid from '@mui/material/Grid';
import {Button} from "@mui/material";
import LazyLoad from "react-lazy-load";
import banner from "../../assets/img/Rectangle 305.png";



const serialize = require('form-serialize');


const My_orders = () => {

    const location_get_urlbk = useLocation();
    const redirect_navigate = useNavigate();
    const [loadinghkfullshow, Setloadinghkfullshow] = useState("false");

    /*  start profile */
    const [wallet_balance, setData_wallet_balance] = useState('0');
    const [first_name_profile,setData_first_name_profile] = useState('');
    const [last_name_profile,setData_last_name_profile] = useState('');
    const [list_order_get,setData_list_order] = useState([]);
    /*  end profile */



    useEffect(() => {
        scrollTo_uphk();
        if(check_login_appbk()==false){
            redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login" );
            return false;
        }
        Load_api_page();

    }, [location_get_urlbk]);

    const Load_api_page= () => {

        if(check_login_appbk()==false){  redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login" ); }

        const config = {
            headers: { Authorization: `Bearer ${Token_get_appbk()}` }
        };

        Setloadinghkfullshow("true");

        axios.post(`${clientconfigwebapp.siteurl}api/v1/dashboard-get`,null,config)
            .then((res) => {
///console.log(res.data);
                Setloadinghkfullshow("false");

                if(String(res.data).length > 0) {

                    if(String(res.data.data)=="login-show"){  redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login" );  } ////dddddd

                    if(String(res.data.wallet_inventory).length > 0) {  setData_wallet_balance(res.data.wallet_inventory); }
                    if (!empty_bk(res.data.first_name_profile)) { setData_first_name_profile(res.data.first_name_profile); localStorage.setItem('first_name_Get',res.data.first_name_profile);    }
                    if (!empty_bk(res.data.last_name_profile)) { setData_last_name_profile(res.data.last_name_profile); localStorage.setItem('last_name_Get',res.data.last_name_profile);    }


                  ///  if(String(res.data.data.total_cource_order).length  > 0) {  setData_total_cource_order(res.data.data.total_cource_order); }
                 if(String(res.data.data.list_order).length > 0) {  setData_list_order(res.data.data.list_order); }


                   /// toast.error('خطای اتصال به سرور کد 7657', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});



                }else{
                    if(String(res.data.msgwebapp).length > 0)  toast.error(res.data.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                }



            }).catch((err) =>{
            Setloadinghkfullshow("false");
            toast.error('خطای اتصال به سرور کد 435346', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
        });





    }







    return (
        <>
            <Master_Front   wallet_balance={wallet_balance} first_name_profile={first_name_profile} last_name_profile={last_name_profile} >
                <ReactFullPageLoadinghk loadinghk={loadinghkfullshow}  />
                <ToastContainer />


                <img src={banner} alt="banner" className='baner-panel'/>

                <section className='w-100 flexRowBetStart account-section-container'>




                    <Grid container direction="row" spacing={2} style={{paddingTop:"14px"}}>


                        <Grid  item className="item_inputbk" lg={3} md={3} sm={12} xs={12} style={{marginTop:"4px"}}>


                            <div className='account-aside'>
                                <Menu_panel wallet_balance={wallet_balance} first_name_profile={first_name_profile} last_name_profile={last_name_profile} />
                            </div>

                        </Grid>


                        <Grid  item className="item_inputbk" lg={9} md={9} sm={12} xs={12} style={{marginTop:"4px"}}>

                            <section className='account-content'>


                                <div className={"title_page_panel"} style={{width: '100%',"marginBottom":"0px", paddingBottom: '0px', display: 'flex', flexFlow: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
                                    <div ><span style={{"color":"var(--c7)","fontFamily":"iran","fontSize":"19px","fontStyle":"normal","fontWeight":"700","lineHeight":"normal","paddingTop":"35px","display":"block","paddingBottom":"28px"}}>سفارشات من ({  list_order_get.length } ) </span></div>
                                </div>



                                { list_order_get.length > 0 ?  (

                                    <div className="box_full_table_typea_bk_v1">

                                        <div className="table_typea_bk" style={{backgroundColor: "transparent"}}>
                                            <div className="table_typea_bk_theader" style={{backgroundColor:"#999282"}}>
                                                <div className="table_typea_bk_header">شماره سفارش</div>
                                                <div className="table_typea_bk_header">عنوان سفارش</div>
                                                <div className="table_typea_bk_header">وضعیت پرداخت</div>
                                                <div className="table_typea_bk_header">تاریخ  ثبت سفارش</div>
                                            </div>



                                            {




                                                list_order_get.map((item_post,index) => {


                                                    return(



                                                        <div className="table_typea_bk_row">


                                                            <div className="table_typea_bk_small">
                                                                <div className="table_typea_bk_cell">شماره سفارش</div>
                                                                <div className="table_typea_bk_cell">
                                                                    {/*<Link style={{"color":"rgb(153 146 130)"}} reloadDocument={true} to={"/panel/my-orders/view/" + String(item_post.id_post) + "/"}>{item_post.id_post}</Link>*/}
                                                                    {item_post.id_post}
                                                                </div>
                                                            </div>

                                                            <div className="table_typea_bk_small">
                                                                <div className="table_typea_bk_cell">عنوان سفارش</div>
                                                                <div className="table_typea_bk_cell">
                                                                    <span>{item_post.title_post}</span>
                                                                </div>
                                                            </div>

                                                            <div className="table_typea_bk_small">
                                                                <div className="table_typea_bk_cell">وضعیت پرداخت</div>

                                                                <div  className="table_typea_bk_cell">
                                                                    {
                                                                        item_post.status_pay=="success" ?  (<Fragment><div style={{"display":"inline-block","padding":"5px","borderRadius":"7px","color":"rgb(43,176,8)","minWidth":"107px"}}>پرداخت موفق</div></Fragment>):(<Fragment></Fragment>)
                                                                    }


                                                                    {
                                                                        item_post.status_pay=="unsuccess" ?  (<Fragment><div style={{"display":"inline-block","padding":"5px","borderRadius":"7px","color":"rgba(210,29,29,0.85)","minWidth":"107px"}}>پرداخت ناموفق</div></Fragment>):(<Fragment></Fragment>)
                                                                    }



                                                                    {
                                                                        item_post.status_pay=="waiting" ?  (<Fragment><div  style={{"display":"inline-block","padding":"5px","borderRadius":"7px","color":"rgb(6,73,243)","minWidth":"107px"}}>در انتظار پرداخت</div></Fragment>):(<Fragment></Fragment>)
                                                                    }

                                                                    {
                                                                        item_post.status_pay=="returned" ?  (<Fragment><div  style={{"display":"inline-block","padding":"5px","borderRadius":"7px","color":"rgba(210,29,29,0.85)","minWidth":"107px"}}>لغو شده</div></Fragment>):(<Fragment></Fragment>)
                                                                    }








                                                                </div>

                                                            </div>


                                                            <div className="table_typea_bk_small">
                                                                <div className="table_typea_bk_cell">تاریخ ثبت سفارش</div>
                                                                <div className="table_typea_bk_cell">
                                                                    <span>{item_post.date_fa}</span>
                                                                </div>
                                                            </div>



                                                        </div>


                                                    )

                                                })

                                            }










                                        </div>
                                    </div>

                                ) : (<Fragment>

                                    <span style={{"display":"block","textAlign":"center","paddingBottom":"32px","paddingTop":"32px"}}>سفارشی  ثبت نشده</span>

                                </Fragment>)

                                }



                                
                                



                            </section>


                        </Grid>






                    </Grid>






                </section>









            </Master_Front>

        </>
    );
}


export default My_orders;